@if (layer$ | async; as layer) {
  <div class="status-content">
    @if (layer?.props?.mapLayerType == 'Boundary') {
      <div>
        <span
          class="boundary-legend-icon"
          [style.background-color]="getSelectionColour()"
          [style.border-color]="layer.props.getLineColor"
          >
        </span>
      </div>
    }
    @if (layer?.props?.mapLayerType == 'Point') {
      <div>
        <span
          class="point-legend-icon"
          [style.background-color]="getSelectionColour()"
          [style.border-color]="layer.props.getLineColor"
          >
        </span>
      </div>
    }
    @if (layer?.props?.mapLayerType == 'Icon') {
      <div>
        <span class="icon-legend-icon">
          <img
            class="icon-size"
        [style.filter]="
          getIconSelectionColour(layer.props.id, layer.props.iconMask)
        "
            [attr.src]="getIconUrl(layer.props)"
            />
          </span>
        </div>
      }
      @if (layer?.props?.mapLayerType == 'Line') {
        <div>
          <span
            class="line-legend-icon"
            [style.background-color]="getSelectionColour()"
            >
          </span>
        </div>
      }
      @if (layer?.props?.mapLayerType == 'InSiteEverywhereMapPin') {
        <div>
          <span class="icon-legend-icon">
            <img
        [style.filter]="
          getIconSelectionColour(layer.props.id, layer.props.iconMask)
        "
              [attr.src]="layer.props.legendInfo[0].iconUrl"
              />
            </span>
          </div>
        }
        @if (isSMFeatureSelected$ | async) {
          <div>
            @if (currentSupplyPoint$ | async; as currentSupplyPoints) {
              <div>
                @if (currentSupplyPoints?.userAction === userAction.Untouched) {
                  <div
                    i18n="@@existingStatus"
                    >
        Existing
      </div>
                }
                @if (
                  currentSupplyPoints?.userAction === userAction.Added &&
                  !currentSupplyPoints?.isClosed
                  ) {
                  <div
                    i18n="@@newStatus"
                    >
        New
      </div>
                }
                @if (
                  currentSupplyPoints?.userAction === userAction.Edited &&
                  !currentSupplyPoints?.isClosed
                  ) {
                  <div
                    i18n="@@editedStatus"
                    >
        Edited
      </div>
                }
                @if (currentSupplyPoints?.isClosed) {
                  <div i18n="@@closedStatus">
        Closed
      </div>
                }
                @if (currentSupplyPoints?.userAction === userAction.Temporary) {
                  <div
                    i18n="@@temporaryStatus"
                    >
        Temporary
      </div>
                }
              </div>
            }
          </div>
        }
        <div class="location-description">
          @if (isLocatorFeatureSelected$ | async) {
            <atlas-edit-location-description
              class="edit-locator-location"
              [currentLocation]="selectedLocation$ | async"
              [areMultipleLocationsSelected]="areMultipleLocationsSelected$ | async"
              [isCatchmentReportingReadonlySystem]="isCatchmentReportingReadOnlySystem$ | async"
            ></atlas-edit-location-description>
          }
        </div>
      </div>
    }
